import { ALL_DATES, nameToRange } from '../components/generic/date-range-picker/date-range-picker.vue';

export default {
    namespaced: true,
    state() {
        const dateRange = nameToRange(ALL_DATES);
        return {
            owners: [],
            properties: [],
            dateRange: { ...dateRange, from: dateRange.from.toISOString(), to: dateRange.to.toISOString() },
            saveToOwnerAccount: false,
            filterBy: 'ONLY_TAX_ON_RENTAL_CHARGES',
            reportType: 'DOWNLOAD',
        };
    },
    getters: {
        owners: state => state.owners,
        properties: state => state.properties,
        dateRange: state => state.dateRange,
        saveToOwnerAccount: state => state.saveToOwnerAccount,
        filterBy: state => state.filterBy,
        reportType: state => state.reportType,
    },
    mutations: {
        setOwners(state, owners) {
            state.owners = owners;
        },
        setProperties(state, properties) {
            state.properties = properties;
        },
        setDateRange(state, dateRange) {
            state.dateRange = dateRange;
        },
        setSaveToOwnerAccount(state, saveToOwnerAccount) {
            state.saveToOwnerAccount = saveToOwnerAccount;
        },
        setFilterBy(state, filterBy) {
            state.filterBy = filterBy;
        },
        setReportType(state, reportType) {
            state.reportType = reportType;
        },
    },
    actions: {
        async changeOwners({ commit }, value) {
            commit('setOwners', value);
        },
        async changeProperties({ commit }, value) {
            commit('setProperties', value);
        },
        async changeDateRange({ commit }, value) {
            commit('setDateRange', value);
        },
        async changeSaveToOwnerAccount({ commit }, value) {
            commit('setSaveToOwnerAccount', value);
        },
        async changeFilterBy({ commit }, value) {
            commit('setFilterBy', value);
        },
        async changeReportType({ commit }, value) {
            commit('setReportType', value);
        },
    },
};
